import { observer } from 'mobx-react-lite';
import React from 'react';
import Hr from "../../../../components/hr/hr";
import { IValidationGroup } from "../../../../hooks/validation-group/validation-group-hook";
import CreateRmaSessionStore from '../../stores/create-rma-session-store';
import RmaLabelFee from "./rma-label-fee";
import RmaReturnFee from "./rma-return-fee";
import ResolveCapability from "../../../../components/resolve-capability/resolve-capability";
import { PROFILE_CAPABILITIES } from "../../../../models/ProfileCapabilities";

interface IRMAFeesSectionProps {
    sessionStore: CreateRmaSessionStore;
    validationGroup: IValidationGroup;
	isPolicyLedMode?: boolean;
}

const RMAFeesSection: React.FC<IRMAFeesSectionProps> = observer(({sessionStore, validationGroup, isPolicyLedMode = false}) => {

    const returnFeeStore = sessionStore.feesListStore.returnFee;
	const labelFeeStore = sessionStore.feesListStore.labelFee;
    
	return (
		<ResolveCapability capability={PROFILE_CAPABILITIES.REFUND_RESOLUTION}>
			{({ isReturnFeeSupported }) => (
                <>
                    {isReturnFeeSupported && (
                        <>
                            <RmaReturnFee store={returnFeeStore} sessionStore={sessionStore} validationGroup={validationGroup}  isPolicyLedMode={isPolicyLedMode}/>
                            <Hr/>
                        </>
                    )}
                    <RmaLabelFee store={labelFeeStore} sessionStore={sessionStore} validationGroup={validationGroup} isPolicyLedMode={isPolicyLedMode}/>
                </>
			)}
		</ResolveCapability>
	)
});

export default RMAFeesSection;
